import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import MarketPlace from './MarketPlace';
//import Health from './Health';
//import HomeServices from './HomeServices';
//import Partners from './Partners';
//import Crave from './Crave';
//import CraveDeepLink from './CraveDeepLink';
import MordeeDeepLink from './MordeeDeepLink';
//import Seekster from './Seekster';
//import Entertainment from './Entertainment';
//import Utilities from './Utilities';
//import SmartSeriesPackage from './SmartSeriesPackage';
//import SmartSeriesItemlist from './SmartSeriesItemlist';
//import SmartShoppingWorkArt from './SmartShoppingWorkArt';
//import SmartLearningWorkart from './SmartLearningWorkart';
//import SmartEntertainmentWorkart from './SmartEntertainmentWorkart';
import Coupon from './Coupon';
import TruexDeeplink from './TruexDeeplink';
import {BrowserRouter, Route, Routes} from "react-router-dom";
//import SmartHealthWorkart from './SmartHealthWorkart';
import {ChakraProvider} from "@chakra-ui/react";
import '@coreui/coreui/dist/css/coreui.min.css'
import './i18n';
//import Lang from './Lang';
import './styles.css'
//import theme from "./Theme/Theme";



ReactDOM.render(
    <ChakraProvider>
        <BrowserRouter>
            <Routes>
                {/* Insert your link here */}
                <Route path="/" element={<App/>}/>
                <Route path="/package" element={<Coupon/>}/>
                <Route path="/openapp" element={<TruexDeeplink/>}/>
                <Route path="/moredee" element={<MordeeDeepLink/>}/>
            </Routes>
        </BrowserRouter>
    </ChakraProvider>,
    document.getElementById('root')
);